<form [formGroup]="editProfileImageForm" (ngSubmit)="onSubmitEditProfileImageForm()" class="content-edit-profile">
  <div class="wrapper-change-image" [ngClass]="{'error': isMaxSizePhotoError}">
    <div class="preview-image-profile">
      <img *ngIf="profileImage" [src]="profileImage" alt="">
      <img *ngIf="!profileImage" [src]="(profileData?.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../assets/images/avatar-user-expert.png' : '../../../assets/images/avatar-user.png'" alt="">
    </div>
    <div class="btn-edit-profile-image">
      <label (click)="triggerFileInput($event)" class="custom-btn custom-btn--white">
        <span>{{'NEW_TEXT.change_profile_photo' | translate}}</span>
      </label>
      <input #fileInput (change)="onFileChange($event)" type="file" accept=".jpg,.jpeg,.png,.svg"/>
    </div>
  </div>
  <div *ngIf="isMaxSizePhotoError" class="wrapper-error-message">
    <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
    <span>{{'NEW_TEXT.your_image_is_too_big_the_maximum_image_size_is' | translate}} 10mb.</span>
  </div>
  <div class="wrapper-list-info-profile">
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.name)">
      <span class="list-profile-label">{{'NEW_TEXT.name' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.name}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.username)">
      <span class="list-profile-label">{{'NEW_TEXT.username' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.username}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.bio)">
      <span class="list-profile-label">{{'NEW_TEXT.bio' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.bio}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.gender)">
      <span class="list-profile-label">{{'NEW_TEXT.gender' | translate}}</span>
      <div class="wrapper-value-info-profile gender">
        <span>{{profileData?.gender}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.phone)">
      <span class="list-profile-label">{{'NEW_TEXT.phone' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.phone_number}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.birthday)">
      <span class="list-profile-label">{{'NEW_TEXT.birthday' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.date_of_birth | date: 'd MMMM yyyy'}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.country)">
      <span class="list-profile-label">{{'NEW_TEXT.country' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.country}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="item-list-info-profile" (click)="changeActiveComponent.emit(EditProfileEnums.city)">
      <span class="list-profile-label">{{'NEW_TEXT.city' | translate}}</span>
      <div class="wrapper-value-info-profile">
        <span>{{profileData?.city}}</span>
        <img src="../../../../assets/icons/icon-arrow-left.svg" alt="">
      </div>
    </div>
    <div class="wrapper-save-btn">
      <button type="submit" [disabled]="!editProfileImageForm.controls['profile_photo'].value" class="custom-btn custom-btn--primary">
        <span>{{'NEW_TEXT.save_changes' | translate}}</span>
      </button>
    </div>
  </div>
</form>
<tl-confirm-modal
  *ngIf="isRemoveImageModalOpen"
  [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
  [modalTitle]="'Remove profile photo?'"
  [confirmBtnText]="'Remove'"
  [modalDescription]="'Are you sure you want to remove profile photo?'"
  (cancelModal)="isRemoveImageModalOpen = false"
  (confirmModal)="onConfirmRemoveFile()">
</tl-confirm-modal>
